import axios from 'axios'

const baseUrl = '/api/v2/me/minhas-vendas'

export default class Client {
  /**
   * @param  {Function} callback
   * @return {Function}
   */
  static async retrieve () {
    return await axios.get(`${baseUrl}/clients`)
  }

  /**
   * @param {*} client
   * @param {*} params
   * @param {*} callback
   */
  static async update (client, params) {
    return await axios.patch(`${baseUrl}/clients/${client}`, params)
  }
}
